// extracted by mini-css-extract-plugin
export default {"chain-select-wrapper":"ChainSelect_chain-select-wrapper__aE8Gg"};